import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i1 from '@angular/animations';
import { style, query, group, animate, keyframes } from '@angular/animations';
import { siSnappyEasingFunction } from '@simpl/siemens-brand-ng/tools';

class SiDropdownMenuDirective {
    constructor(templateRef, viewContainerRef, renderer2) {
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.renderer2 = renderer2;
    }
    open() {
        this.viewRef = this.viewContainerRef.createEmbeddedView(this.templateRef);
        const [element] = this.viewRef.rootNodes;
        this.renderer2.addClass(element, 'd-block');
    }
    close() {
        this.viewRef?.destroy();
        this.viewRef = undefined;
    }
    toggle() {
        if (this.viewRef) {
            this.close();
        }
        else {
            this.open();
        }
    }
    get isOpen() {
        return !!this.viewRef;
    }
}
SiDropdownMenuDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiDropdownMenuDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
SiDropdownMenuDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.7", type: SiDropdownMenuDirective, selector: "[siDropdownMenu]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiDropdownMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[siDropdownMenu]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: i0.Renderer2 }]; } });

const easedStates = Array(100).fill(0)
    .map((v, i) => siSnappyEasingFunction((i + 1) / 100));
const expandStandaloneAnimation = [
    style({
        transformOrigin: '50% 0',
    }),
    query('.si-dropdown-menu-standalone-wrapper', style({
        transformOrigin: '50% 0',
    })),
    query('.si-dropdown-border-loader', style({ width: '100%' })),
    group([
        animate('150ms', keyframes(easedStates.map(state => style({ transform: `scale(1, ${state}) translateZ(0)` })))),
        query('.si-dropdown-menu-standalone-wrapper', animate('150ms', keyframes(easedStates.map(state => style({ transform: `scale(1, ${1 / state}) translateZ(0)` }))))),
        query('.si-dropdown-border-loader', animate('100ms 50ms ease', style({ width: '0%' }))),
    ]),
];

class SiDropdownMenuStandaloneComponent {
    constructor(elementRef, renderer2, animationBuilder) {
        this.elementRef = elementRef;
        this.renderer2 = renderer2;
        this.animationBuilder = animationBuilder;
    }
    ngOnInit() {
        const animation = this.animationBuilder.build(expandStandaloneAnimation);
        const player = animation.create(this.elementRef.nativeElement);
        player.onDone(() => player.destroy());
        player.play();
    }
}
SiDropdownMenuStandaloneComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiDropdownMenuStandaloneComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1.AnimationBuilder }], target: i0.ɵɵFactoryTarget.Component });
SiDropdownMenuStandaloneComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.7", type: SiDropdownMenuStandaloneComponent, selector: "si-dropdown-menu-standalone", ngImport: i0, template: "<div class=\"si-dropdown-menu-standalone-wrapper\">\n    <div class=\"dropdown-menu si-dropdown-menu-standalone d-block\">\n        <div class=\"si-triangle-top\"></div>\n        <div class=\"si-dropdown-border-loader\"></div>\n        <ng-content></ng-content>\n    </div>\n</div>\n", styles: [":host{overflow:hidden;position:absolute}.si-dropdown-menu-standalone{position:relative}.si-dropdown-menu-standalone-wrapper{padding-top:1px;margin-top:-1px}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiDropdownMenuStandaloneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-dropdown-menu-standalone', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"si-dropdown-menu-standalone-wrapper\">\n    <div class=\"dropdown-menu si-dropdown-menu-standalone d-block\">\n        <div class=\"si-triangle-top\"></div>\n        <div class=\"si-dropdown-border-loader\"></div>\n        <ng-content></ng-content>\n    </div>\n</div>\n", styles: [":host{overflow:hidden;position:absolute}.si-dropdown-menu-standalone{position:relative}.si-dropdown-menu-standalone-wrapper{padding-top:1px;margin-top:-1px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.AnimationBuilder }]; } });

class SiDropdownMenuModule {
}
SiDropdownMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiDropdownMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SiDropdownMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.7", ngImport: i0, type: SiDropdownMenuModule, declarations: [SiDropdownMenuDirective, SiDropdownMenuStandaloneComponent], imports: [CommonModule], exports: [SiDropdownMenuDirective, SiDropdownMenuStandaloneComponent] });
SiDropdownMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiDropdownMenuModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiDropdownMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiDropdownMenuDirective, SiDropdownMenuStandaloneComponent],
                    imports: [
                        CommonModule,
                    ],
                    exports: [SiDropdownMenuDirective, SiDropdownMenuStandaloneComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SiDropdownMenuDirective, SiDropdownMenuModule, SiDropdownMenuStandaloneComponent };
